var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 135.716,
    height: 40.019,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 31.8,
    y1: 183.29,
    x2: 15.017,
    y2: 166.508,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    spreadMethod: "pad",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00a0ff"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00a1ff"
    },
    offset: 0.007
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00beff"
    },
    offset: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00d2ff"
    },
    offset: 0.512
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00dfff"
    },
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00e3ff"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 43.834,
    y1: 171.999,
    x2: 19.638,
    y2: 171.999,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    spreadMethod: "pad",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffe000"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ffbd00"
    },
    offset: 0.409
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "orange"
    },
    offset: 0.775
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ff9c00"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 34.827,
    y1: 169.704,
    x2: 12.069,
    y2: 146.946,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    spreadMethod: "pad",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#ff3a44"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#c31162"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17.297,
    y1: 191.824,
    x2: 27.46,
    y2: 181.661,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.8 0 0 -.8 0 161.6)",
    spreadMethod: "pad",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#32a071"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#2da771"
    },
    offset: 0.069
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#15cf74"
    },
    offset: 0.476
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#06e775"
    },
    offset: 0.801
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#00f076"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 48,
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.625 20.695-11.613-6.597c-.649-.371-1.231-.344-1.606-.008l-.058-.063.058-.058c.375-.336.957-.36 1.606.011l11.687 6.641-.074.074z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 48,
    id: "r"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.348 14.145c-.235.246-.371.628-.371 1.125v-.118c0-.496.136-.879.371-1.125l.058.063-.058.055z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 48,
    id: "u"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.613 22.961-3.988-2.266.074-.074 3.914 2.223c.559.316.836.734.836 1.156-.047-.379-.332-.75-.836-1.039z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("pattern", {
    patternTransform: "matrix(1 0 0 -1 0 48)",
    patternUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 48,
    id: "x"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.012 33.902 15.601-8.863c.508-.289.789-.66.836-1.039 0 .418-.277.836-.836 1.156L18.012 34.02c-1.117.632-2.035.105-2.035-1.176v-.114c0 1.278.918 1.805 2.035 1.172z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "m"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "#000",
      fillOpacity: 0.2,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "p"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "#000",
      fillOpacity: 0.12000002,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "s"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "#000",
      fillOpacity: 0.12000002,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    id: "v"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "#000",
      fillOpacity: 0.25,
      fillRule: "nonzero",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M112 8H12c-2.199 0-4 1.801-4 4v24c0 2.199 1.801 4 4 4h100c2.199 0 4-1.801 4-4V12c0-2.199-1.801-4-4-4z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 39.359A3.363 3.363 0 0 0 115.359 36V12A3.363 3.363 0 0 0 112 8.641H12A3.363 3.363 0 0 0 8.641 12v24A3.363 3.363 0 0 0 12 39.359h100m0 .641H12c-2.199 0-4-1.801-4-4V12c0-2.199 1.801-4 4-4h100c2.199 0 4 1.801 4 4v24c0 2.199-1.801 4-4 4z",
    style: {
      fill: "#a6a6a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.934 16.195c0 .668-.2 1.203-.594 1.602-.453.473-1.043.711-1.766.711a2.426 2.426 0 0 1-1.765-.719c-.485-.484-.727-1.078-.727-1.789 0-.711.242-1.305.727-1.785a2.414 2.414 0 0 1 1.765-.723c.344 0 .672.071.985.203.312.133.566.313.75.535l-.418.422c-.321-.379-.758-.566-1.317-.566-.504 0-.941.176-1.312.531-.367.356-.551.817-.551 1.383 0 .566.184 1.031.551 1.387a1.85 1.85 0 0 0 1.312.531c.535 0 .985-.18 1.34-.535.234-.235.367-.559.402-.973h-1.742v-.578h2.324c.028.125.036.246.036.363zM49.621 14.191h-2.183v1.52h1.968v.578h-1.968v1.52h2.183v.589H46.82v-4.796h2.801v.589zM52.223 18.398h-.618v-4.207h-1.339v-.589h3.297v.589h-1.34v4.207zM55.949 18.398v-4.796h.617v4.796h-.617zM59.301 18.398h-.613v-4.207h-1.344v-.589h3.301v.589h-1.344v4.207zM66.887 17.781c-.473.485-1.059.727-1.758.727-.703 0-1.289-.242-1.762-.727-.472-.484-.707-1.078-.707-1.781 0-.703.235-1.297.707-1.781.473-.485 1.059-.727 1.762-.727.695 0 1.281.242 1.754.731.476.488.711 1.078.711 1.777 0 .703-.235 1.297-.707 1.781zm-3.063-.402c.356.359.789.539 1.305.539.512 0 .949-.18 1.301-.539.355-.359.535-.82.535-1.379s-.18-1.02-.535-1.379a1.756 1.756 0 0 0-1.301-.539c-.516 0-.949.18-1.305.539-.355.359-.535.82-.535 1.379s.18 1.02.535 1.379zM68.461 18.398v-4.796h.75l2.332 3.73h.027l-.027-.922v-2.808h.617v4.796h-.644l-2.442-3.914h-.027l.027.926v2.988h-.613z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 0.16,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.25299 0 0 1.23841 -9.796 -9.594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.508 22.598c-1.879 0-3.414-1.43-3.414-3.403 0-1.957 1.535-3.402 3.414-3.402 1.883 0 3.418 1.445 3.418 3.402 0 1.973-1.535 3.403-3.418 3.403zm0-5.465c-1.031 0-1.918.851-1.918 2.062 0 1.227.887 2.063 1.918 2.063s1.922-.836 1.922-2.063c0-1.211-.891-2.062-1.922-2.062zm-7.449 5.465c-1.883 0-3.414-1.43-3.414-3.403 0-1.957 1.531-3.402 3.414-3.402 1.882 0 3.414 1.445 3.414 3.402 0 1.973-1.532 3.403-3.414 3.403zm0-5.465c-1.032 0-1.922.851-1.922 2.062 0 1.227.89 2.063 1.922 2.063 1.031 0 1.918-.836 1.918-2.063 0-1.211-.887-2.062-1.918-2.062zm-8.864 4.422v-1.446h3.453c-.101-.808-.371-1.402-.785-1.816-.504-.5-1.289-1.055-2.668-1.055-2.125 0-3.789 1.715-3.789 3.84s1.664 3.84 3.789 3.84a3.662 3.662 0 0 0 2.602-1.031l1.019 1.019c-.863.824-2.011 1.457-3.621 1.457-2.914 0-5.363-2.371-5.363-5.285s2.449-5.285 5.363-5.285c1.575 0 2.758.516 3.688 1.484.953.953 1.25 2.293 1.25 3.375 0 .336-.028.645-.078.903h-4.86zm36.246-1.121c-.281.761-1.148 2.164-2.914 2.164-1.75 0-3.207-1.379-3.207-3.403 0-1.906 1.442-3.402 3.375-3.402 1.563 0 2.465.953 2.836 1.508l-1.16.773c-.387-.566-.914-.941-1.676-.941-.757 0-1.3.347-1.648 1.031l4.551 1.883-.157.387zm-4.64-1.133c-.039 1.312 1.019 1.984 1.777 1.984.594 0 1.098-.297 1.266-.722l-3.043-1.262ZM74.102 16h1.496v10h-1.496V16zm-2.45 5.84h-.05c-.336.398-.977.758-1.789.758-1.704 0-3.262-1.496-3.262-3.414 0-1.907 1.558-3.391 3.262-3.391.812 0 1.453.363 1.789.773h.05v-.488c0-1.301-.695-2-1.816-2-.914 0-1.481.66-1.715 1.215l-1.301-.543c.375-.902 1.368-2.012 3.016-2.012 1.754 0 3.234 1.032 3.234 3.543v6.11h-1.418v-.551zm-1.711-4.707c-1.031 0-1.894.863-1.894 2.051 0 1.199.863 2.074 1.894 2.074 1.016 0 1.817-.875 1.817-2.074 0-1.188-.801-2.051-1.817-2.051zM89.445 26h-3.578V16h1.492v3.789h2.086c1.657 0 3.282 1.199 3.282 3.106 0 1.906-1.629 3.105-3.282 3.105zm.039-4.82h-2.125v3.429h2.125c1.114 0 1.75-.925 1.75-1.714 0-.774-.636-1.715-1.75-1.715zm9.223 1.437c-1.078 0-2.199-.476-2.66-1.531l1.324-.555c.285.555.809.735 1.363.735.774 0 1.559-.465 1.571-1.286v-.105c-.27.156-.848.387-1.559.387-1.426 0-2.879-.785-2.879-2.25 0-1.34 1.168-2.203 2.481-2.203 1.004 0 1.558.453 1.906.98h.051v-.773h1.441v3.836c0 1.773-1.324 2.765-3.039 2.765zm-.18-5.48c-.488 0-1.168.242-1.168.847 0 .774.848 1.071 1.582 1.071.657 0 .965-.145 1.364-.336a1.811 1.811 0 0 0-1.778-1.582zm8.469 5.261-1.715-4.335h-.051l-1.773 4.335h-1.609l2.664-6.058-1.52-3.371h1.559l4.105 9.429h-1.66zM93.547 16h1.496v10h-1.496V16z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.348 33.969c-.235-.246-.371-.629-.371-1.125V15.152c0-.496.136-.879.371-1.125l.058-.054 9.914 9.91v.234l-9.914 9.91-.058-.058z",
    style: {
      fill: "url(#i)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.621 20.578-3.301 3.305v.234l3.305 3.305.074-.043 3.914-2.227c1.117-.632 1.117-1.672 0-2.308l-3.914-2.223-.078-.043z",
    style: {
      fill: "url(#j)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.699 20.621 26.32 24l-9.972-9.973c.371-.39.976-.437 1.664-.047l11.687 6.641",
    style: {
      fill: "url(#k)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.699 27.379 18.012 34.02c-.688.386-1.293.339-1.664-.051L26.32 24l3.379 3.379z",
    style: {
      fill: "url(#l)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "url(#o)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "url(#r)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "url(#u)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#v)",
    transform: "matrix(1.25299 0 0 -1.23841 -9.796 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h124v48H0V0Z",
    style: {
      fill: "url(#x)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayButton);
export default __webpack_public_path__ + "static/media/google-play-button.a05322895214ef7e79936a2f53ec5c90.svg";
export { ForwardRef as ReactComponent };